/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IAddEditStatusModalControllerScope extends IBaseModalControllerScope {
        model: models.AddEditStatusModel;
        deleteStatus() : void;
    }

    export class AddEditStatusModalController extends BaseModalController {
        scope: IAddEditStatusModalControllerScope;

        constructor(
            $scope: IAddEditStatusModalControllerScope,
            model: models.AddEditStatusModel,
            close: any)
        {
            super($scope, close);
            this.scope = $scope;

            this.scope.model = model;
            this.scope.deleteStatus = () => this.deleteStatus();
        }

        private deleteStatus(): void {
            this.scope.model.deleteStatusCode = true;
            this.dismissModal(true);
        }
    }
}

warsApp.registerController('AddEditStatusModalController', ['$scope', 'model', 'close']);